import { combineReducers } from 'redux';
import { selectRunnerId } from './auth';
import prepareBody from '../utils/prepareBody';

export const FETCH_JOURNEY = 'FETCH_JOURNEY';
export const FETCH_JOURNEY_SUCCESS = 'FETCH_JOURNEY_SUCCESS';
export const FETCH_JOURNEY_FAILURE = 'FETCH_JOURNEY_FAILURE';

export function current(state = {}, action) {
    switch (action.type) {
        case FETCH_JOURNEY:
            return {};
        case FETCH_JOURNEY_SUCCESS:
            return action.result.Current ? action.result.Current[0] : null;
        default:
            return state;
    }
}

export function next(state = {}, action) {
    switch (action.type) {
        case FETCH_JOURNEY:
            return {};
        case FETCH_JOURNEY_SUCCESS:
            return action.result.Next;
        default:
            return state;
    }
}

export function complete(state = [], action) {
    switch (action.type) {
        case FETCH_JOURNEY:
            return [];
        case FETCH_JOURNEY_SUCCESS:
            return action.result.Complete;
        default:
            return state;
    }
}

export function overviewText(state = [], action) {
    switch (action.type) {
        case FETCH_JOURNEY_SUCCESS:
            return action.result.JourneyText;
        default:
            return state;
    }
}

export function loading(state = true, action) {
    switch (action.type) {
        case FETCH_JOURNEY:
            return true;
        case FETCH_JOURNEY_SUCCESS:
        case FETCH_JOURNEY_FAILURE:
            return false;
        default:
            return state;
    }
}

export default combineReducers({
    current,
    next,
    complete,
    loading,
    overviewText,
});

export const fetchJourney = () => ({
    types: [FETCH_JOURNEY, FETCH_JOURNEY_SUCCESS, FETCH_JOURNEY_FAILURE],
    promise: ({ getState }) => (
        fetch(`${process.env.RTAPI_URL}/API_journey.php`, {
            method: 'POST',
            body: prepareBody({
                runner_id: selectRunnerId(getState()),
            }),
        }).then(res => res.json())
    ),
});



/** WEBPACK FOOTER **
 ** ./src/redux/journey.js
 **/